import script from "./address-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./address-list.vue?vue&type=script&lang=ts&setup=true"

import "./address-list.vue?vue&type=style&index=0&id=54fbeb6c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54fbeb6c"]])

export default __exports__